import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Whatsapp from "../components/Whatsapp";
import plot from "../assets/images/plotting.png";
import villa from "../assets/images/villa1.png";
import apartment from "../assets/images/apartment1.png";
import house from "../assets/images/home.png";
import aboutImage from "../assets/images/sir.png";
import graph from "../assets/images/graph1.jpg";
// import "../assets/css/bootstrap/bootstrap.min.css";
import "../assets/css/font-awesome/all.min.css";
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/owl-carousel/owl.carousel.min.css";
import "../assets/css/magnific-popup/magnific-popup.css";
import "../assets/css/style.css";
import VideoBanner from "../components/VideoBanner";

const About = () => {
  return (
    <div>
      <Navbar />
      {/* add video here */}
      <VideoBanner />


      <section className="about-intro-section">
        <div className="container">
          <div className="about-intro-grid">
            <div className="about-intro-visual">
              <div className="about-image-frame">
                <img src={aboutImage} alt="Modern residential property" className="about-intro-image" />
                <div className="about-image-caption">Creating better places to live</div>
              </div>
            </div>
            <div className="about-intro-content">
              <span className="about-eyebrow">YARRAMSETTI NALLABABU GARU</span>
              <h1 className="about-intro-heading">
                Building trust into <span>every address.</span>
              </h1>
              <div className="about-experience-highlight" aria-label="24 years experience">
                <div className="about-experience-number">24</div>
                <div className="about-experience-copy">
                  <span>Years of experience</span>
                  <small>in building better spaces</small>
                </div>
              </div>
              <p className="about-intro-text" style={{textAlign: "justify"}}>
                Devi Vinayaka Builders, a leading Construction and Developer company, established at Rajahmundry in 2002 by a team of young professionals who seek to provide the best services to our clients. Devi Vinayaka Builders provides civil construction services and interior solutions. Devi Vinayaka Builders by a team of experienced builders and dynamic designers, we are dedicated to provide superior service, grounded with honesty and integrity, we focus on your wishes and precise requirements to deliver cost-effective solutions with high quality.
              </p>
              <p className="about-intro-text" style={{textAlign: "justify"}}>
                In a few years of operation, the company has developed more than 2 lakh Sq. ft. of premium living, retail and work spaces under various stages of development. Today, the company is a leader and a trendsetter in the construction industry, delivering custom-designed projects in the residential, commercial, space.              </p>
              <div className="about-intro-actions">
                <a href="/contact" className="about-brochure-button">
                  Contact us <span aria-hidden="true">&#8594;</span>
                </a>
              </div>
              {/* <div className="about-intro-points">
                <div><strong>01</strong><span>Quality-led development</span></div>
                <div><strong>02</strong><span>Transparent process</span></div>
                <div><strong>03</strong><span>Long-term value</span></div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      <section className="about-services-section">
        <div className="container">
          <div className="about-services-heading">
            <div>
              <span className="about-services-eyebrow">WHAT WE CREATE</span>
              <h2>OUR SERVICES</h2>
            </div>
            <p>
              Spaces shaped around your goals, from a well-planned plot to a
              complete home designed for comfortable living.
            </p>
          </div>
          <div className="about-services-grid">
            <article className="about-service-card">
              <span className="about-service-number">01</span>
              <img src={plot} alt="Plots" />
              <h3>PLOTS</h3>
              <p>Build your future on a secure and thoughtfully planned foundation.</p>
              <a href="/Projects">Explore plots <span aria-hidden="true">&#8594;</span></a>
            </article>
            <article className="about-service-card">
              <span className="about-service-number">02</span>
              <img src={villa} alt="Villas" />
              <h3>VILLAS</h3>
              <p>Enjoy generous spaces, privacy, and a lifestyle made for your family.</p>
              <a href="/Projects">Explore villas <span aria-hidden="true">&#8594;</span></a>
            </article>
            <article className="about-service-card">
              <span className="about-service-number">03</span>
              <img src={apartment} alt="Apartments" />
              <h3>APARTMENTS</h3>
              <p>Modern homes that bring convenience, connection, and lasting value.</p>
              <a href="/Projects">Explore apartments <span aria-hidden="true">&#8594;</span></a>
            </article>
            <article className="about-service-card">
              <span className="about-service-number">04</span>
              <img src={house} alt="Houses" />
              <h3>HOUSES</h3>
              <p>Comfortable, welcoming homes created for the moments that matter.</p>
              <a href="/Projects">Explore houses <span aria-hidden="true">&#8594;</span></a>
            </article>
          </div>
        </div>
      </section>

      <section className="about-features-section">
        <div className="container">
          <div className="about-features-heading">
            <div>
              <span>BUILT AROUND YOUR LIFESTYLE</span>
              <h2>Project features</h2>
            </div>
            <p>
              Every essential is thoughtfully planned to make your community
              comfortable, secure, and ready for the future.
            </p>
          </div>
          <div className="about-features-grid">
            <article className="about-feature-item">
              <span>01</span>
              <h3>100% Vaastu</h3>
              <p>Homes and spaces planned with thoughtful orientation.</p>
            </article>
            <article className="about-feature-item">
              <span>02</span>
              <h3>Grand entrance</h3>
              <p>A welcoming entrance gate with a distinctive arch.</p>
            </article>
            <article className="about-feature-item">
              <span>03</span>
              <h3>24/7 security</h3>
              <p>Reliable security for peace of mind every day.</p>
            </article>
            <article className="about-feature-item">
              <span>04</span>
              <h3>40 ft. BT roads</h3>
              <p>Wide, well-built roads for easier movement and access.</p>
            </article>
            <article className="about-feature-item">
              <span>05</span>
              <h3>Children's play area</h3>
              <p>A dedicated space for play, discovery, and connection.</p>
            </article>
            <article className="about-feature-item">
              <span>06</span>
              <h3>Avenue plantations</h3>
              <p>Green surroundings that bring freshness to the community.</p>
            </article>
            <article className="about-feature-item">
              <span>07</span>
              <h3>Water and electricity</h3>
              <p>Essential infrastructure planned for everyday convenience.</p>
            </article>
            <article className="about-feature-item">
              <span>08</span>
              <h3>Club house and pool</h3>
              <p>Spaces to relax, gather, and enjoy quality leisure time.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="vision-mission-section">
        <div className="container">
          <div className="vision-mission-grid">
            <div className="vision-mission-copy">
              <span className="section-kicker">OUR PRINCIPLES</span>
              <h2>Built on vision, driven by purpose.</h2>

              <div className="vision-stack">
                <div className="vision-statement">
                  <span className="statement-label">OUR VISION</span>
                  <p>
                    To redefine real estate by delivering exceptional properties that blend
                    innovation, sustainability, and modern living with lasting value.
                  </p>
                </div>

                <div className="vision-statement mission-statement">
                  <span className="statement-label">OUR MISSION</span>
                  <ul>
                    <li>Deliver quality homes with thoughtful design and lasting standards.</li>
                    <li>Build trust through honest guidance, transparency, and strong relationships.</li>
                    <li>Create communities that support comfortable, modern, and confident living.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="vision-mission-visual">
              <div className="vision-visual-card">
                <img src={graph} alt="Our Vision & Mission" className="vision-mission-img" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Whatsapp />
      <Footer />
    </div>
  );
};
export default About;
